interface UserBasedRouteOptions {
  internal: React.ComponentType;
  external: React.ComponentType;
  adminOne?: React.ComponentType;
}

export const userTypeRouting = (opts: UserBasedRouteOptions) => {
  if (opts.adminOne && site.permissions.canAccessAdminOne) {
    return opts.adminOne;
  }

  if (!site.currentEnvironment) {
    return opts.external;
  }

  if (site.currentEnvironment.type === "internal") {
    return opts.internal;
  }

  return opts.external;
};